module.exports = __webpack_public_path__ + "img/banner-formulario.8701257e.jpg";